import { render, staticRenderFns } from "./ButtonSample.vue?vue&type=template&id=3caf2c0e&"
import script from "./ButtonSample.js?vue&type=script&lang=js&"
export * from "./ButtonSample.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports